// @generated by protoc-gen-connect-es v1.4.0
// @generated from file penumbra/core/component/compact_block/v1/compact_block.proto (package penumbra.core.component.compact_block.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CompactBlockRangeRequest, CompactBlockRangeResponse, CompactBlockRequest, CompactBlockResponse } from "@buf/penumbra-zone_penumbra.bufbuild_es/penumbra/core/component/compact_block/v1/compact_block_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Query operations for the compact block component.
 *
 * @generated from service penumbra.core.component.compact_block.v1.QueryService
 */
export const QueryService = {
  typeName: "penumbra.core.component.compact_block.v1.QueryService",
  methods: {
    /**
     * Returns a stream of compact blocks, optionally keeping the stream alive for push notifications.
     *
     * @generated from rpc penumbra.core.component.compact_block.v1.QueryService.CompactBlockRange
     */
    compactBlockRange: {
      name: "CompactBlockRange",
      I: CompactBlockRangeRequest,
      O: CompactBlockRangeResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Returns a single compact block at a specific height.
     *
     * Clients requesting multiple compact blocks should generally use the streaming RPC.
     *
     * @generated from rpc penumbra.core.component.compact_block.v1.QueryService.CompactBlock
     */
    compactBlock: {
      name: "CompactBlock",
      I: CompactBlockRequest,
      O: CompactBlockResponse,
      kind: MethodKind.Unary,
    },
  }
};

